import { Facebook, Twitter, Linkedin, MessageCircle, Link2 } from "lucide-react";
import { toast } from "sonner";

export function ShareButtons({ title = "NERO SUN", className = "" }) {
  const open = (platform) => {
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(title);
    const map = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      twitter: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
      whatsapp: `https://wa.me/?text=${text}%20${url}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    };
    window.open(map[platform], "_blank", "noopener,noreferrer,width=620,height=520");
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Link copied");
    } catch {
      toast.error("Couldn't copy link");
    }
  };

  const btn =
    "w-9 h-9 flex items-center justify-center border border-white/15 text-foreground/70 hover:border-signal hover:text-signal transition-colors";

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="share-buttons">
      <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mr-1">Share</span>
      <button data-testid="share-facebook" onClick={() => open("facebook")} className={btn} aria-label="Share on Facebook"><Facebook className="w-4 h-4" /></button>
      <button data-testid="share-twitter" onClick={() => open("twitter")} className={btn} aria-label="Share on X"><Twitter className="w-4 h-4" /></button>
      <button data-testid="share-whatsapp" onClick={() => open("whatsapp")} className={btn} aria-label="Share on WhatsApp"><MessageCircle className="w-4 h-4" /></button>
      <button data-testid="share-linkedin" onClick={() => open("linkedin")} className={btn} aria-label="Share on LinkedIn"><Linkedin className="w-4 h-4" /></button>
      <button data-testid="share-copy" onClick={copy} className={btn} aria-label="Copy link"><Link2 className="w-4 h-4" /></button>
    </div>
  );
}
